import includes from "lodash/includes";
export var isTesting = process.env.NODE_ENV === "test";
export var isTest = isTesting;
export var isDev = process.env.NODE_ENV === "development";
export var isProd = process.env.NODE_ENV === "production";
export var isProduction = isProd;
export var isServer = typeof window === "undefined";
export var isClient = !isServer;
var host = !isServer && window && window.location && window.location.hostname ? window.location.hostname : "";
export var isHomeSite = includes(host, "home.classdojo") || includes(host, "home2.classdojo") || includes(host, "home3.classdojo");
export function overrideIsDev(override) {
  isDev = override;
}
//# sourceMappingURL=env.js.map